import { render, staticRenderFns } from "./side-black-popup.vue?vue&type=template&id=6c1a5bbb&scoped=true"
import script from "./side-black-popup.vue?vue&type=script&lang=js"
export * from "./side-black-popup.vue?vue&type=script&lang=js"
import style0 from "./side-black-popup.vue?vue&type=style&index=0&id=6c1a5bbb&prod&lang=less&scoped=true"
import style1 from "./side-black-popup.vue?vue&type=style&index=1&id=6c1a5bbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1a5bbb",
  null
  
)

export default component.exports